import type { NavigateOptions } from "react-router";
import _ from "underscore";
import { convertHashPath } from "@/shared/ui/Link.tsx";
import { getCvPartner } from "./getCvPartner.ts";

export const navigateTo = async (route: string, opts?: NavigateOptions) => {
  if (!_.isString(route)) {
    return;
  }
  const replacedRoute = convertHashPath(route);

  await getCvPartner().navigate(replacedRoute, opts);
};

export const redirectTo = (path: string) => {
  window.location.href = path;
};

// For leaving a page the user should not be on, where a history entry would let
// the back button return to it and bounce forward again
export const replaceWith = (path: string) => {
  window.location.replace(path);
};
